unit UFirstLogin;

interface

uses
  System.SysUtils, WEBLib.Crypto, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.WebCtrls, WEBLib.Toast;

type

  TfrmFirstLogin = class(TForm)
    divFirstLoginOuterContainer: THTMLDiv;
    divFIrstLoginContainer: THTMLDiv;
    lblPasswordRepeat: TLabel;
    lblUserManagement: TLabel;
    lblPassword: TLabel;
    btnSave: TButton;
    edtPasswordRepeat: TEdit;
    edtPassword: TEdit;
    toastMessage: TToast;
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormShow(Sender: TObject);
    [async]procedure btnSaveClick(Sender: TObject); async;
  private
    FUserMail: String;
    FFirstLogin: Boolean;
    procedure SetUserMail(const Value: String);
    procedure SetFirstLogin(const Value: Boolean);
  protected
    [async] function SetPassword(aPassword : String) : Boolean; async;
    function CheckPassword : Boolean;

  public
    property UserMail : String read FUserMail write SetUserMail;
    property FirstLogin : Boolean read FFirstLogin write SetFirstLogin;
  protected procedure LoadDFMValues; override; end;

var
  frmFirstLogin: TfrmFirstLogin;

implementation

uses
  UDatamodule, XData.Web.Client, UErrorHandling, UHelper, UCustomerSelect, ULogin,
  UResources;

{$R *.dfm}

{ TfrmFirstLogin }


procedure TfrmFirstLogin.btnSaveClick(Sender: TObject);
var
  tmpResult : Boolean;
  lform: TfrmLogin;
begin
  if FUserMail <> '' then
  begin
    if CheckPassword then
    begin
      tmpResult := await(SetPassword(edtPassword.Text));

      if tmpResult then
      begin
        toastMessage.Items.Items[0].Show;
        UDM.Form := sPageLogin;
        if Assigned(lform) then
        begin
          lform.Close;
        end;
        lform := TfrmLogin.CreateNew(divFirstLoginOuterContainer.ElementID, nil);
        Application.Navigate('https://fliegel-portal.de', ntPage);
      end
      else
      begin
        toastMessage.Items.Items[1].Show;
      end;
    end
    else
    begin
      MessageDlg('Passwörter stimmen nicht überein oder leeres Passwort vergeben. Bitte korrigieren.', mtError, [mbAbort]);
    end;
  end
  else
  begin
    MessageDlg('Fehler aufgetreten.', mtError, [mbAbort]);
  end;
end;


function TfrmFirstLogin.CheckPassword: Boolean;
begin
  Result := ((edtPassword.Text = edtPasswordRepeat.Text)
      AND (edtPassword.Text <> ''));
end;


procedure TfrmFirstLogin.SetFirstLogin(const Value: Boolean);
begin
  FFirstLogin := Value;
end;


function TfrmFirstLogin.SetPassword(aPassword: String): Boolean;
var
  LResponse: TXDataClientResponse;
begin

  try
    if FFirstLogin then
    begin
      LResponse :=
        await(
          TXDataClientResponse,
          UDM.XDataWebClient.RawInvokeAsync('IUsers.SetFirstPassword',
          [FUserMail, UDM.PasswordToken, aPassword])
        );
    end
    else
    begin
      LResponse :=
        await(
          TXDataClientResponse,
          UDM.XDataWebClient.RawInvokeAsync('IUsers.SetPasswordAfterReset',
          [FUserMail, UDM.PasswordToken, aPassword])
        );
    end;

    if LResponse.StatusCode = 204 then
    begin
      Result := true;
    end;

  except
    on E: EXDataClientRequestException do
    begin
      TErrorHandling.DisplayServerError(E);
    end;
  end;
end;


procedure TfrmFirstLogin.SetUserMail(const Value: String);
begin
  FUserMail := Value;
end;


procedure TfrmFirstLogin.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Action := TCloseAction.caFree;
end;

procedure TfrmFirstLogin.WebFormShow(Sender: TObject);
begin
  {$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.FirstLoginInit();
//    pas.UJSHelper.THTMLComponents.CheckLanguage();
    pas.UJSHelper.THTMLComponents.SetEvents();
  end;
  {$ENDIF}

end;


procedure TfrmFirstLogin.LoadDFMValues;
begin
  inherited LoadDFMValues;

  divFirstLoginOuterContainer := THTMLDiv.Create('wcIDFirstLoginContent');
  divFIrstLoginContainer := THTMLDiv.Create('wcIDFirstLoginContainer');
  lblPasswordRepeat := TLabel.Create('wcIDPasswordRepeat');
  lblUserManagement := TLabel.Create('wcIDHeading');
  lblPassword := TLabel.Create('wcIDPassword');
  btnSave := TButton.Create('wcIDSavePasswordBtn');
  edtPasswordRepeat := TEdit.Create('wcIDPasswordRepeatInput');
  edtPassword := TEdit.Create('wcIDPasswordInput');
  toastMessage := TToast.Create(Self);

  divFirstLoginOuterContainer.BeforeLoadDFMValues;
  divFIrstLoginContainer.BeforeLoadDFMValues;
  lblPasswordRepeat.BeforeLoadDFMValues;
  lblUserManagement.BeforeLoadDFMValues;
  lblPassword.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  edtPasswordRepeat.BeforeLoadDFMValues;
  edtPassword.BeforeLoadDFMValues;
  toastMessage.BeforeLoadDFMValues;
  try
    Name := 'frmFirstLogin';
    Width := 916;
    Height := 366;
    CSSLibrary := cssBootstrap;
    ElementClassName := 'panels-light-yellow';
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    divFirstLoginOuterContainer.SetParentComponent(Self);
    divFirstLoginOuterContainer.Name := 'divFirstLoginOuterContainer';
    divFirstLoginOuterContainer.Left := 0;
    divFirstLoginOuterContainer.Top := 0;
    divFirstLoginOuterContainer.Width := 916;
    divFirstLoginOuterContainer.Height := 366;
    divFirstLoginOuterContainer.HeightStyle := ssAuto;
    divFirstLoginOuterContainer.WidthStyle := ssAuto;
    divFirstLoginOuterContainer.Align := alClient;
    divFirstLoginOuterContainer.ChildOrder := 1;
    divFirstLoginOuterContainer.ElementPosition := epIgnore;
    divFirstLoginOuterContainer.ElementFont := efCSS;
    divFirstLoginOuterContainer.Role := '';
    divFIrstLoginContainer.SetParentComponent(divFirstLoginOuterContainer);
    divFIrstLoginContainer.Name := 'divFIrstLoginContainer';
    divFIrstLoginContainer.Left := 0;
    divFIrstLoginContainer.Top := 0;
    divFIrstLoginContainer.Width := 916;
    divFIrstLoginContainer.Height := 366;
    divFIrstLoginContainer.HeightStyle := ssAuto;
    divFIrstLoginContainer.WidthStyle := ssAuto;
    divFIrstLoginContainer.Align := alClient;
    divFIrstLoginContainer.ChildOrder := 31;
    divFIrstLoginContainer.ElementPosition := epIgnore;
    divFIrstLoginContainer.ElementFont := efCSS;
    divFIrstLoginContainer.Role := '';
    lblPasswordRepeat.SetParentComponent(divFIrstLoginContainer);
    lblPasswordRepeat.Name := 'lblPasswordRepeat';
    lblPasswordRepeat.Left := 67;
    lblPasswordRepeat.Top := 187;
    lblPasswordRepeat.Width := 285;
    lblPasswordRepeat.Height := 35;
    lblPasswordRepeat.Caption := 'Password wiederholen';
    lblPasswordRepeat.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLUserLbl';
    lblPasswordRepeat.ElementFont := efCSS;
    lblPasswordRepeat.ElementPosition := epIgnore;
    lblPasswordRepeat.Font.Charset := DEFAULT_CHARSET;
    lblPasswordRepeat.Font.Color := clWindowText;
    lblPasswordRepeat.Font.Height := -29;
    lblPasswordRepeat.Font.Name := 'Tahoma';
    lblPasswordRepeat.Font.Style := [];
    lblPasswordRepeat.HeightStyle := ssAuto;
    lblPasswordRepeat.HeightPercent := 100.000000000000000000;
    lblPasswordRepeat.ParentFont := False;
    lblPasswordRepeat.WidthStyle := ssAuto;
    lblPasswordRepeat.WidthPercent := 100.000000000000000000;
    lblUserManagement.SetParentComponent(divFIrstLoginContainer);
    lblUserManagement.Name := 'lblUserManagement';
    lblUserManagement.Left := 259;
    lblUserManagement.Top := 23;
    lblUserManagement.Width := 676;
    lblUserManagement.Height := 58;
    lblUserManagement.AutoSize := False;
    lblUserManagement.Caption := 'Passwort vergeben';
    lblUserManagement.ElementClassName := 'control-label col-xl-9 col-lg-9 col-md-7 display-5 mb-5 wcCLLaundryLbl';
    lblUserManagement.ElementFont := efCSS;
    lblUserManagement.ElementPosition := epIgnore;
    lblUserManagement.Font.Charset := DEFAULT_CHARSET;
    lblUserManagement.Font.Color := clWindowText;
    lblUserManagement.Font.Height := -48;
    lblUserManagement.Font.Name := 'Tahoma';
    lblUserManagement.Font.Style := [];
    lblUserManagement.HeightStyle := ssAuto;
    lblUserManagement.HeightPercent := 100.000000000000000000;
    lblUserManagement.ParentFont := False;
    lblUserManagement.WidthStyle := ssAuto;
    lblUserManagement.WidthPercent := 100.000000000000000000;
    lblPassword.SetParentComponent(divFIrstLoginContainer);
    lblPassword.Name := 'lblPassword';
    lblPassword.Left := 67;
    lblPassword.Top := 130;
    lblPassword.Width := 121;
    lblPassword.Height := 35;
    lblPassword.Caption := 'Password';
    lblPassword.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLUserLbl';
    lblPassword.ElementFont := efCSS;
    lblPassword.ElementPosition := epIgnore;
    lblPassword.Font.Charset := DEFAULT_CHARSET;
    lblPassword.Font.Color := clWindowText;
    lblPassword.Font.Height := -29;
    lblPassword.Font.Name := 'Tahoma';
    lblPassword.Font.Style := [];
    lblPassword.HeightStyle := ssAuto;
    lblPassword.HeightPercent := 100.000000000000000000;
    lblPassword.ParentFont := False;
    lblPassword.WidthStyle := ssAuto;
    lblPassword.WidthPercent := 100.000000000000000000;
    btnSave.SetParentComponent(divFIrstLoginContainer);
    btnSave.Name := 'btnSave';
    btnSave.Left := 305;
    btnSave.Top := 297;
    btnSave.Width := 145;
    btnSave.Height := 50;
    btnSave.Anchors := [akLeft,akBottom];
    btnSave.Caption := 'Speichern';
    btnSave.ChildOrder := 25;
    btnSave.ElementClassName := 'btn btn-primary wcCLSavePasswordBtn';
    btnSave.ElementFont := efCSS;
    btnSave.ElementPosition := epIgnore;
    btnSave.Font.Charset := DEFAULT_CHARSET;
    btnSave.Font.Color := clWindowText;
    btnSave.Font.Height := -19;
    btnSave.Font.Name := 'Tahoma';
    btnSave.Font.Style := [];
    btnSave.HeightStyle := ssAuto;
    btnSave.HeightPercent := 100.000000000000000000;
    btnSave.ParentFont := False;
    btnSave.TabOrder := 9;
    btnSave.WidthStyle := ssAuto;
    btnSave.WidthPercent := 100.000000000000000000;
    SetEvent(btnSave, Self, 'OnClick', 'btnSaveClick');
    edtPasswordRepeat.SetParentComponent(divFIrstLoginContainer);
    edtPasswordRepeat.Name := 'edtPasswordRepeat';
    edtPasswordRepeat.Left := 422;
    edtPasswordRepeat.Top := 187;
    edtPasswordRepeat.Width := 322;
    edtPasswordRepeat.Height := 35;
    edtPasswordRepeat.ChildOrder := 3;
    edtPasswordRepeat.ElementClassName := 'form-control';
    edtPasswordRepeat.ElementPosition := epIgnore;
    edtPasswordRepeat.Font.Charset := DEFAULT_CHARSET;
    edtPasswordRepeat.Font.Color := clWindowText;
    edtPasswordRepeat.Font.Height := -27;
    edtPasswordRepeat.Font.Name := 'Tahoma';
    edtPasswordRepeat.Font.Style := [];
    edtPasswordRepeat.HeightStyle := ssAuto;
    edtPasswordRepeat.HeightPercent := 100.000000000000000000;
    edtPasswordRepeat.ParentFont := False;
    edtPasswordRepeat.PasswordChar := #12;
    edtPasswordRepeat.TabOrder := 5;
    edtPasswordRepeat.WidthStyle := ssAuto;
    edtPasswordRepeat.WidthPercent := 100.000000000000000000;
    edtPassword.SetParentComponent(divFIrstLoginContainer);
    edtPassword.Name := 'edtPassword';
    edtPassword.Left := 422;
    edtPassword.Top := 129;
    edtPassword.Width := 322;
    edtPassword.Height := 35;
    edtPassword.ChildOrder := 3;
    edtPassword.ElementClassName := 'form-control';
    edtPassword.ElementPosition := epIgnore;
    edtPassword.Font.Charset := DEFAULT_CHARSET;
    edtPassword.Font.Color := clWindowText;
    edtPassword.Font.Height := -27;
    edtPassword.Font.Name := 'Tahoma';
    edtPassword.Font.Style := [];
    edtPassword.HeightStyle := ssAuto;
    edtPassword.HeightPercent := 100.000000000000000000;
    edtPassword.ParentFont := False;
    edtPassword.PasswordChar := #12;
    edtPassword.TabOrder := 7;
    edtPassword.WidthStyle := ssAuto;
    edtPassword.WidthPercent := 100.000000000000000000;
    toastMessage.SetParentComponent(Self);
    toastMessage.Name := 'toastMessage';
    toastMessage.AutoHideDelay := 2000;
    toastMessage.Items.Clear;
    with toastMessage.Items.Add do
    begin
      AutoHide := True;
      Body := '<font color="gray" style="font-size: 8pt">&#x25FC;</font><b style="font-size: 78t">Ihr Password wurde erfolgreich gesetzt. Sie k'+#246'nnen sich nun anmelden.</b>';
      Time := ttNone;
      Header := '<b style="font-size: 12pt">Information</b>';
    end;
    with toastMessage.Items.Add do
    begin
      AutoHide := True;
      Body := '<font color="gray" style="font-size: 8pt">&#x25FC;</font><b style="font-size: 78t">Ihr Password konnte nicht gesetzt werden. Bitte versuchen Sie es erneut.</b>';
      Time := ttNone;
      Header := '<b style="font-size: 12pt">Information</b>';
    end;
    toastMessage.Position := tpAbsolute;
    toastMessage.Left := 824;
    toastMessage.Top := 40;
  finally
    divFirstLoginOuterContainer.AfterLoadDFMValues;
    divFIrstLoginContainer.AfterLoadDFMValues;
    lblPasswordRepeat.AfterLoadDFMValues;
    lblUserManagement.AfterLoadDFMValues;
    lblPassword.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    edtPasswordRepeat.AfterLoadDFMValues;
    edtPassword.AfterLoadDFMValues;
    toastMessage.AfterLoadDFMValues;
  end;
end;

initialization

RegisterClass(TfrmFirstLogin);

end.
